/**
 * Product page recommendations — Liquid-rendered only.
 *
 * The recs list is rendered server-side by Liquid using
 * `shop.metafields.upsell.product_rules` for overrides and the
 * 'weaving-patterns-and-kits' collection + tag matching for type-based recs.
 * This file only wires the delegated ATC click handler for the
 * Liquid-rendered cards.
 */
(function () {
  'use strict';

  function handleRecAtcClick(btn) {
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1, properties: { _source: 'product_rec' } }),
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        btn.textContent = 'Added!';
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        if (window.refreshCart) window.refreshCart(cart);
        if (window.jQuery) {
          window.jQuery('.cart-container').addClass('active');
          window.jQuery('body').removeClass('overlay-removed').addClass('locked');
          if (window.PXUTheme && window.PXUTheme.media_queries && window.PXUTheme.media_queries.medium.matches) {
            window.jQuery('body').addClass('blocked-scroll');
          }
        }
        setTimeout(function () {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1500);
      })
      .catch(function () {
        btn.textContent = originalText;
        btn.disabled = false;
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-product-recommendations-results] [data-pattern-add-to-cart]');
    if (!btn) return;
    e.preventDefault();
    handleRecAtcClick(btn);
  });
})();
